import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_J_CASHOUT = '/spe-j-cash-out';
const SPE_N_TRANSACTION_APPROVAL = '/spe-n-transaction-approval';
let SpeJCashOutProxy = class SpeJCashOutProxy {
    constructor(api) {
        this.api = api;
    }
    getAccountbydocument(uuidWhiteLabel, document) {
        const uri = `${SPE_J_CASHOUT}/api/ted/check-document/white-label/${uuidWhiteLabel}/document/${document}`;
        return this.api.get(uri);
    }
    effectTransfer(uuidWhiteLabel, document, transferBody) {
        const uri = `${SPE_N_TRANSACTION_APPROVAL}/api/ted/execute-operation/white-label/${uuidWhiteLabel}/document/${document}`; // proxiado pelo spe-n-transaction-approve
        // uuidAccountPayment
        return this.api.post(uri, transferBody, transferBody.uuidAccountPayment);
    }
    /**
     * @description Proxy que tem a responsabilidade por validar
     * o codigo de barras informado
     * @param code
     */
    postBillet(code, isBarCode, uuidWhiteLabel, uuidAccountPayment) {
        const data = {
            lineConsult: code,
            isBarCode: isBarCode,
            uuidWhiteLabel: uuidWhiteLabel,
            uuidAccountPayment: uuidAccountPayment,
        };
        const uri = `${SPE_J_CASHOUT}/api/payment/consult`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
    /**
     * @description Proxy que se comunica com a rota responsavel
     * por confirmar o pagamento de boleto e pegar os dados do extrato
     *
     * @param uuid
     */
    postBilletConfirm(data) {
        const uri = `${SPE_N_TRANSACTION_APPROVAL}/api/payment`; // proxiado pelo spe-n-transaction-approve
        return this.api.post(uri, data, data.uuidAccountPayment);
    }
    postLiquidation(uuidAccountPayment, data) {
        const uri = `${SPE_J_CASHOUT}/api/billet/liquidation`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
    pixTransaction(data, userId) {
        const uri = `${SPE_N_TRANSACTION_APPROVAL}/api/pix/transaction/`; // proxiado pelo spe-n-transaction-approve
        return this.api.post(uri, data, data.uuidAccountPayment);
    }
    pixCheckReturnAllowed(transactionId, returnValue) {
        const uri = `${SPE_J_CASHOUT}/api/pix/transaction/check-return-allowed/${transactionId}/?returnValue=${returnValue}`;
        return this.api.post(uri);
    }
};
SpeJCashOutProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJCashOutProxy = __decorate([
    Injectable()
], SpeJCashOutProxy);

const SPE_N_TRANSACTION_APPROVAL$1 = '/spe-n-transaction-approval';
let SpeNTransactionApprovalProxy = class SpeNTransactionApprovalProxy {
    constructor(api) {
        this.api = api;
    }
    getTransactions(uuidAccountPayment, uuidWhiteLabel, params = {}) {
        params.uuidAccountPayment = uuidAccountPayment;
        params.uuidWhiteLabel = uuidWhiteLabel;
        let uri = `${SPE_N_TRANSACTION_APPROVAL$1}/v1/transactions`;
        let isFirst = true;
        Object.keys(params).forEach((param) => {
            if (params[param] !== null && params[param] !== undefined) {
                if (isFirst) {
                    uri += `?`;
                    isFirst = false;
                }
                else {
                    uri += `&`;
                }
                uri += `${param}=${params[param]}`;
            }
        });
        return this.api.get(uri);
    }
    approveTransactions(uuidAccountPayment, payload) {
        const uri = `${SPE_N_TRANSACTION_APPROVAL$1}/v1/approval`;
        return this.api.post(uri, payload, uuidAccountPayment);
    }
    rejectTransactions(uuidAccountPayment, payload) {
        const uri = `${SPE_N_TRANSACTION_APPROVAL$1}/v1/disapproval`;
        return this.api.post(uri, payload, uuidAccountPayment);
    }
};
SpeNTransactionApprovalProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNTransactionApprovalProxy = __decorate([
    Injectable()
], SpeNTransactionApprovalProxy);

const SPE_J_CHECK_EVENT = '/spe-j-check-event';
let SpeJCheckEventProxy = class SpeJCheckEventProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * @description Valida se a operação está autorizada
     * @param checkEventBody
     */
    validateOperation(checkEventBody) {
        const uri = `${SPE_J_CHECK_EVENT}/api/check-event/`;
        return this.api.post(uri, checkEventBody);
    }
};
SpeJCheckEventProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJCheckEventProxy = __decorate([
    Injectable()
], SpeJCheckEventProxy);

const SPE_J_FUNDS = '/spe-j-funds';
let SpeJFundsProxy = class SpeJFundsProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckStatement(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatementCard(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/card/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatementPIX(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/pix/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getLatestTransactionPix(uuidWhilabel, uuidAccountPayment, quantity, typeOrigin) {
        /* const uri = `${SPE_J_FUNDS}/api/statement/pix/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?quantity=${quantity}`; */
        const uri = `${SPE_J_FUNDS}/api/statement/last-registers/type-origin/${typeOrigin}/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/number/${quantity}`;
        return this.api.get(uri);
    }
    getAllStatement(operationDescription, uuidTransactionGroup, limit, page) {
        const uri = `${SPE_J_FUNDS}/api/statement/all?operationDescription=${operationDescription}&uuidTransactionGroup=${uuidTransactionGroup}&limit=${limit}&page=${page}`;
        return this.api.get(uri);
    }
};
SpeJFundsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJFundsProxy = __decorate([
    Injectable()
], SpeJFundsProxy);

const SPE_N_ACCOUNT = '/spe-n-account';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    postCard(uuid) {
        const uri = `${SPE_N_ACCOUNT}/v1/add-card/${uuid}`;
        return this.api.post(uri);
    }
};
SpeNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountProxy = __decorate([
    Injectable()
], SpeNAccountProxy);

const SPE_N_ACCOUNT$1 = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    decodeQrcode(uuidAccountPaymentPay, encode) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/decode-qr-onus`;
        return this.api.post(uri, { encode, uuidAccountPaymentPay });
    }
};
SpeNAccountsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountsProxy = __decorate([
    Injectable()
], SpeNAccountsProxy);

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCep(zipcode) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cep/${zipcode}`;
        return this.api.get(uri);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

const SPE_N_PAYMENT_VOUNCHER = '/spe-view-n-payment-voucher';
let SpeNPaymentVoucherProxy = class SpeNPaymentVoucherProxy {
    constructor(api) {
        this.api = api;
    }
    findTransactionIdConsult(transactionIdConsult) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/transaction-id/${transactionIdConsult}`;
        return this.api.get(uri);
    }
    findUuidWhiteLabel(uuidWhiteLabel) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/whitelabel/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findAllAccountPayment(uuidAccount) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}`;
        return this.api.get(uri);
    }
    findBarCode(barCode) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/barcode/${barCode}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPayment(uuidAccount, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/type-voucher/${typeVoucher}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndAccountDestination(uuidAccount, accountDestination, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/account-destination/${accountDestination}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndDocumentDestination(uuidAccount, documentDestination, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/document-destination/${documentDestination}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
};
SpeNPaymentVoucherProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNPaymentVoucherProxy = __decorate([
    Injectable()
], SpeNPaymentVoucherProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getAccountPaymentPerson(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment-person/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getClientLimitRate(uuidWl, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/limit-rate/white-label/${uuidWl}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getTaxesTariff(uuidWl, uuidAccount) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/taxes-tariff/white-label/${uuidWl}/account-payment/${uuidAccount}/`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

let UiPxCashOutModule = class UiPxCashOutModule {
};
UiPxCashOutModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [
            ConfigService,
            SpeJCashOutProxy,
            SpeJCheckEventProxy,
            SpeJFundsProxy,
            SpeNAccountProxy,
            SpeNAccountsProxy,
            SpeNOpenAccountProxy,
            SpeNPaymentVoucherProxy,
            SpeViewNAccountProxy,
            SpeNTransactionApprovalProxy,
        ],
    })
], UiPxCashOutModule);

/*
 * Public API Surface of ui-px-cashout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJCashOutProxy, SpeJCheckEventProxy, SpeJFundsProxy, SpeNAccountProxy, SpeNAccountsProxy, SpeNOpenAccountProxy, SpeNPaymentVoucherProxy, SpeNTransactionApprovalProxy, SpeViewNAccountProxy, UiPxCashOutModule };
//# sourceMappingURL=wlp-ui-px-cashout.js.map
